/**
 * Copyright Mántum All Rights Reserved.
 */
import TextButton from '../../common/button/text';
import ContainedButton from '../../common/button/contained';
import AlertButton from '../../common/button/alert';
import { useState } from 'react';

type PropTypes = {
    testid?: string;
    title?: string;
    name?: string;
    value?: string;
    children?: React.ReactNode;
    disabled?: boolean;
    advanced?: Record<string, unknown>;
    onClick?: (name?: string, value?: unknown) => void;
};

export default function ExternalAction(props: PropTypes) {
    const variant = props.advanced?.variant || 'text';
    const isExternal = props.advanced?.external || false;
    const disabled = props.disabled || false;

    const [loading, setLoading] = useState(false);

    const onClick = () => {
        setLoading(true);
        if (props.value && typeof props.value === 'string' && isExternal) {
            if (typeof window !== 'undefined') {
                const url = new URL(props.value);
                window.open(url, '_blank', 'noopener noreferrer');
            }
        }

        if (props.onClick) {
            props.onClick(props.name, props.value);
        }
        setLoading(false);
    };

    if (variant === 'alert') {
        return (
            <AlertButton
                disabled={disabled}
                title={props.title}
                testid={props.testid}
                loading={loading}
                onClick={onClick}
            >
                {props.children}
            </AlertButton>
        );
    }

    if (variant === 'contained') {
        return (
            <ContainedButton
                disabled={disabled}
                title={props.title}
                testid={props.testid}
                loading={loading}
                onClick={onClick}
            >
                {props.children}
            </ContainedButton>
        );
    }

    return (
        <TextButton
            disabled={disabled}
            title={props.title}
            testid={props.testid}
            loading={loading}
            onClick={onClick}
        >
            {props.children}
        </TextButton>
    );
}
